/**
 * All scrollable descendants of a root element (overflow auto/scroll with real overflow).
 *
 * @param {HTMLElement|null} root
 * @returns {Array<HTMLElement>}
 */
const getScrollableDescendants = root => {
  if (!root) {
    return [];
  }

  return [...root.querySelectorAll('*')].filter(element => {
    const { overflowY } = getComputedStyle(element);

    return (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      element.scrollHeight > element.clientHeight + 1
    );
  });
};

/**
 * The largest scroll container under a root — the page's primary scroller. Used as the restore
 * target when the originally-scrolled node was replaced by a re-render on reactivation.
 *
 * @param {HTMLElement|null} root
 * @returns {HTMLElement|null}
 */
export const getPrimaryScroller = root => {
  const scrollers = getScrollableDescendants(root);

  if (scrollers.length === 0) {
    return null;
  }

  return scrollers.reduce((largest, candidate) =>
    candidate.scrollHeight - candidate.clientHeight > largest.scrollHeight - largest.clientHeight
      ? candidate
      : largest,
  );
};
